import React from 'react';

const formModal = {
    "connectionName": { "label": "Connection Name", "name": "name", "type": "text", "text_value": "", "required": true },
    "emailType": { "label": "Email Configuration Type", "name": "type", "type": "text", "text_value": "", "required": true },
    // "emailType": {
    //     "label": "Email Configuration Type", "name": "emailType", "type": "dropdown", "text_value": "", "options": [
    //         { "name": "Select Email Configuration Type", "value": "" },
    //         { "name": "EWS", "value": "ews" },
    //         { "name": "SMTP", "value": "smtp" },
    //     ], "required": true
    // },
    "host": { "label": "Host", "name": "host", "type": "text", "text_value": "", "required": true },
    "username": { "label": "Username", "name": "username", "type": "text", "text_value": "", "required": true },
    "password": { "label": "Password", "name": "password", "type": "password", "text_value": "", "required": true },
    "ewsVersionDisplay": { "label": "EWS Version", "name": "version", "type": "dropdown", "text_value": "", "options": [
        { "name": "Select EWS Version", "value": "" },
        { "name": "Exchange2007", "value": "Exchange2007" },
        { "name": "Exchange2007_SP1", "value": "Exchange2007_SP1" },
        { "name": "Exchange2010", "value": "Exchange2010" },
        { "name": "Exchange2010_SP1", "value": "Exchange2010_SP1" },
        { "name": "Exchange2010_SP2", "value": "Exchange2010_SP2" },
        { "name": "Exchange2013", "value": "Exchange2013" },
        { "name": "Exchange2013_SP1", "value": "Exchange2013_SP1" }
    ], "required": true },
}

const modalConfig = {
    "addEmailConfigModal": {
        "id": "addEmailConfigModal", "form_id": "addEmailConfigForm", "form_name": "addEmailConfigForm", "title": "Email Configuration Details", "body": null, "button_name": "Verify & Save", "display": true, buttonType: "submit"
    }
};

export function ModalDetails(setModalInformation) {
    let formData = JSON.parse(JSON.stringify(formModal))
    let config = JSON.parse(JSON.stringify(modalConfig['addEmailConfigModal']));

    config['formKey'] = `addEmailConfigForm_${Math.floor(Math.random() * 10)}`;
    config['isLoading'] = false;
    setModalInformation({ modal: config, formData: formData });
    setTimeout(() => {
        jQuery("#addEmailConfigModal").modal('toggle');
    }, 5);
}

